import { handleActions } from 'redux-actions';
import { initialState } from './constants';
import { getLocationsHash } from './actions';

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [getLocationsHash]: {
    next: (state: State.Locations, action: any): State.Locations => ({
      ...state,
      locationsHash: action.payload,
      locationsFetched: true,
    }),

    throw: (state: State.Locations, action: any): State.Locations => ({
      ...state,
      error: action.payload,
    }),
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
export default handleActions(ACTION_HANDLERS, initialState);
